import { Component, OnInit,Input,SimpleChanges,OnChanges } from '@angular/core';
import { TenderService } from '../../../services/tender.service';
import {ChangeDetectorRef} from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tender-detail',
  templateUrl: './tender-detail.component.html',
  styleUrls: ['./tender-detail.component.scss']
})
export class TenderDetailComponent implements OnInit,OnChanges {

  @Input() tenderid: any;
  @Input() type: any="";
  loading:boolean=false;
  data:any;
  files_upload:any[]=[];
  constructor(private ref: ChangeDetectorRef,private tenderService:TenderService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.tenderid);
    this.detail();
  }

  detail(){
    this.loading = true;
    this.tenderService.detail(this.tenderid,this.type).subscribe(resp=>{
      this.loading = false;
     if(resp.data){
      this.data = resp.data;
      this.getDocList();
      this.ref.detectChanges();
     }
     
    },error=> this.loading = false);
  }

  getDocList(){
    this.tenderService.list_file(this.data["postId"]).subscribe(resp=>{
      this.files_upload = resp.data;
    })
  }

  pdf(){
    this.loading= true;
    this.tenderService.download_detail(this.data.id).subscribe(resp=>{
      if(resp){
        let file = new Blob([resp], { type: 'application/pdf' });            
        var fileURL = URL.createObjectURL(file);
        // this.tryDoctype = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);;
        window.open(fileURL);
      }
      this.loading= false;
      this.ref.detectChanges();
    },err=>{
      this.loading= false;
      this.ref.detectChanges();
      this.alert("Failed to view pdf","error");
      console.log(err)
    })

  }

  alert(msg, status) {
    Swal.fire({
      text: msg,
      icon: status,
      buttonsStyling: false,
      confirmButtonText: "Ok",
      customClass: {
        confirmButton: "btn font-weight-bold btn-primary"
      }
    }).then((result) => {
      if (result.value) {
      
      }

    })
  }
}
